/**
 * @desc getEbsSkuCost
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: Array<string>,
  params: API.fulfilment.test.getEbsSkuCost.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/test/getEbsSkuCost`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
